import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';

export const permissionGuard = (requiredPermission: string): CanActivateFn => {
  return (route, state) => {
    const authService = inject(AuthenticationService);
    const router = inject(Router);

    const user = authService.loggedUser$.value;

    if (!user || !user.roles || user.roles.length === 0) {
      router.navigateByUrl('/auth/company-select');
      return false;
    }

    const userPermissions = user.roles
      .filter(role => !!role?.permissions && role.permissions.length > 0)
      .flatMap(role => role.permissions!)
      .map(permission => permission.key)
      .filter((key, index, self) => !!key && self.indexOf(key) === index);

    const hasPermission = userPermissions.includes(requiredPermission);

    if (!hasPermission) {
      console.warn(
        `[permissionGuard] Permission "${requiredPermission}" denied. Current permissions:`,
        userPermissions
      );
    }

    if (!hasPermission) {
      router.navigateByUrl('/auth/company-select');
      return false;
    }

    return true;
  };
};
